import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Error handling for third-party scripts
if (typeof window !== 'undefined') {
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (source?.includes('posthog') || 
        message?.includes('PerformanceServerTiming') ||
        message?.includes('DataCloneError')) {
      return true;
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  window.onunhandledrejection = function(event) {
    if (event.reason?.message?.includes('PerformanceServerTiming') ||
        event.reason?.message?.includes('posthog')) {
      event.preventDefault();
      return;
    }
  };
}

// Register Service Worker for PWA - ENABLED for PWABuilder compliance
const registerServiceWorker = async () => { return; // DISABLED - causing fetch issues
  if (!('serviceWorker' in navigator)) {
    console.log('[PWA] Service Workers not supported');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js', {
      scope: '/'
    });
    
    console.log('[PWA] Service Worker registered successfully');
    console.log('[PWA] Scope:', registration.scope);

    // Check for updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('[PWA] New version available');
            } else {
              console.log('[PWA] Content cached for offline use');
            }
          }
        });
      }
    });
  } catch (error) {
    console.error('[PWA] Service Worker registration failed:', error);
  }
};

// Register SW on page load
if (typeof window !== 'undefined') {
  window.addEventListener('load', registerServiceWorker);
  
  // Remove Emergent badge
  const removeBadge = () => {
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.remove();
  };
  
  // Run immediately and on intervals
  removeBadge();
  window.addEventListener('load', removeBadge);
  window.addEventListener('DOMContentLoaded', removeBadge);
  setInterval(removeBadge, 500);
  
  // Use MutationObserver
  const observer = new MutationObserver(removeBadge);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    window.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
